module.exports = __webpack_public_path__ + "img/Feature.02b8527c.jpg";